import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import core from '@gin-betting/core';
import { difference, throttle } from 'lodash';

import gc from 'services/garbage-collector';

const {
    utils: { locateReachableMatchIds },
} = gc;

const {
    hooks: { useDeepMemo },
    entities: {
        actions: { getOddsStatistic },
    },
} = core;

const throttledLocateReachableMatchIds = throttle(locateReachableMatchIds, 300);

const useOddsStatisticFetcher = (): void => {
    const dispatch = useDispatch();
    const cache = useRef<string[]>([]);

    // NOTE: Don't remove 'useLocation'! Location is used inside 'locateReachableMatchIds' util!
    const { pathname } = useLocation();

    useEffect(() => {
        // NOTE: Clear "cache" because GC clear "oddsStatistic" and "oddsStatisticMarkets".
        cache.current = [];
    }, [pathname]);

    const reachableMatchIds = useSelector(throttledLocateReachableMatchIds);

    const sportEventIds = difference(reachableMatchIds, cache.current);
    const memSportEventIds = useDeepMemo(sportEventIds);

    useEffect(() => {
        if (memSportEventIds.length === 0) return;

        dispatch(getOddsStatistic(memSportEventIds));

        cache.current = cache.current.concat(memSportEventIds);
    }, [dispatch, memSportEventIds]);
};

export default useOddsStatisticFetcher;
